// R8: the step-3 Create Account gate — the Auth0 signup handoff is blocked
// unless the Terms of Service AND Privacy Policy acceptances are both checked,
// plus the R5 category belt (categoryGateBlocksAdvance). This is the COMPLETE
// completion predicate: no other condition — in particular no payment-method
// requirement (R9/D1) — gates registration completion for any customer
// category.
//
// Kept dependency-free (no workspace imports) so the spec property probes
// under internal/proptests can compile this source directly, mirroring
// categoryGate.ts.

import {
  categoryGateBlocksAdvance,
  type RegistrationAccountMode,
  type RegistrationUsageIntent,
} from './categoryGate';

export interface HandoffGateInput {
  acceptTerms: boolean;
  acceptPrivacy: boolean;
  usageType: RegistrationUsageIntent;
  accountType: RegistrationAccountMode;
  selectedCategory: string;
}

// The exact boolean the Create Account button's disabled prop and the
// handleCreateAccount guard evaluate.
export function handoffBlocked(input: HandoffGateInput): boolean {
  return (
    !input.acceptTerms ||
    !input.acceptPrivacy ||
    categoryGateBlocksAdvance(input.usageType, input.accountType, input.selectedCategory)
  );
}
